







import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import createjs from 'createjs-npm';
import { Loading } from '../common/loading';

@Component({
  components: {
  },
})
export default class extends Vue {
    private app: any;

    private mounted() {
      const that: any = this;
      this.app = new createjs.Stage('loading');
      class CurrentGame extends Loading {
        constructor(options: any) {
          super(options);
          // this.config = config
        }

        protected init() {
          const bg = new createjs.Bitmap(require('@/assets/images/game/shooter/lbg.jpg'));
          const cloudBottom = new createjs.Bitmap(require('@/assets/images/game/linker/cb.png'));
          const cloudLeft = new createjs.Bitmap(require('@/assets/images/game/linker/cl.png'));
          const cloudRight = new createjs.Bitmap(require('@/assets/images/game/linker/cr.png'));
          const plane = new createjs.Bitmap(require('@/assets/images/game/linker/pl.png'));
          const text = new createjs.Bitmap(require('@/assets/images/game/linker/loading.png'));
          const cloud = new createjs.Bitmap(require('@/assets/images/game/linker/cloud0.png'));

          const overlayContainer = new createjs.Container();
          const shape = new createjs.Shape();
          shape.graphics.beginFill('#f6f9e9').drawRect(0, 0, 1650, 1080);
          shape.x = 270;
          overlayContainer.addChild(shape, cloud);

          cloudBottom.setTransform(0, 660, 1, 1, 0, 0, 0, 0, 0);
          cloudLeft.setTransform(0, 0, 1, 1, 0, 0, 0, 0, 0);
          cloudRight.setTransform(1617, 0, 1, 1, 0, 0, 0, 0, 0);
          plane.setTransform(1920 + 329, 401, 1, 1, 0, 0, 0, 0, 0);
          text.setTransform(1920 + 673, 445, 1, 1, 0, 0, 0, 0, 0);
          that.app.stage.addChild(bg, cloudBottom, cloudLeft, cloudRight, plane, text);

          createjs.Tween.get(plane)
            .to({ x: 419 }, 3000, createjs.Ease.easeOut)
            .call(() => {
              createjs.Tween.get(plane, { loop: true })
                .to({ y: 380 }, 2000, createjs.Ease.easeOut)
                .to({ y: 410 }, 2000, createjs.Ease.easeOut);
            });

          createjs.Tween.get(text)
            .to({ x: 786 }, 3000, createjs.Ease.easeOut)
            .call(() => {
              createjs.Tween.get(text, { loop: true })
                .to({ y: 475 }, 2000, createjs.Ease.easeOut)
                .to({ y: 445 }, 2000, createjs.Ease.easeOut);
            });

          createjs.Tween.get(cloudBottom, { loop: true })
            .to({ y: 680 }, 2000, createjs.Ease.easeOut)
            .to({ y: 660 }, 2000, createjs.Ease.easeOut);

          createjs.Tween.get(cloudLeft, { loop: true })
            .to({ y: -20 }, 2000, createjs.Ease.easeOut)
            .to({ y: 0 }, 2000, createjs.Ease.easeOut);

          createjs.Tween.get(cloudRight, { loop: true })
            .to({ y: -20 }, 2000, createjs.Ease.easeOut)
            .to({ y: 0 }, 2000, createjs.Ease.easeOut);

          this.makeResponsive(true, 'both', false, 1, {
            canvas: 'loading',
          }, that.app);
          this.startAnimation(that.app.stage);
        }
      }
      const game = new CurrentGame({});
    }
}
